import _get from 'lodash/get'

export const get_gift_card_types = state => _get(state, 'giftcards.giftCardTypes')
export const get_issued_gift_cards = state => _get(state, 'giftcards.issuedGiftCards')
